export function SET_IS_ACTIVE(state, payload) {
  state['isActive'] = payload;
}
export function SET_DIALOG_OPEN(state, payload) {
  state['isDialogOpen'] = payload;
}